var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"identify-code",on:{"click":_vm.handleClick}},_vm._l((_vm.identifyCode),function(char,index){return _c('span',{key:index,staticClass:"code-char",style:({ animationDelay: `${index * 0.1}s` })},[_vm._v("\n    "+_vm._s(char)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }